export default "__VITE_ASSET__cNTN71TK__"